import { render, staticRenderFns } from "./VehicleIssues.vue?vue&type=template&id=68cd4d9a&scoped=true&"
import script from "./VehicleIssues.vue?vue&type=script&lang=ts&"
export * from "./VehicleIssues.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleIssues.vue?vue&type=style&index=0&id=68cd4d9a&scoped=true&lang=scss&"
import style1 from "./VehicleIssues.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd4d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VChip,VTextField,VToolbar,VToolbarTitle})
